module.exports = __webpack_public_path__ + "static/media/26.65a146c1.png";